module.exports = __webpack_public_path__ + "img/id.ad68ea7c.png";